module.exports = __webpack_public_path__ + "static/scale-model-of-beachwood-canyon-in-glendale-california-62751882991a2cfa9d7c878a2850ec06.png";